import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-message-dialog-cutomizado',
  templateUrl: './message-dialog-cutomizado.component.html',
  styleUrls: ['./message-dialog-cutomizado.component.css'],
  imports: [MatDialogModule]
})
export class MessageDialogCutomizadoComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) { }
}
